import AttestationDefSelect from '@/generated/controls/attestationDef/AttestationDefSelect.vue';
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  extends: AttestationDefSelect
})

